/* Product description "Read more" clamp (styles in description-clamp.css).
   Full text always stays in the DOM; JS only adds a max-height clamp,
   fade and toggle button when the description actually overflows. */
(function () {
  'use strict';

  if (window.themeDescClampLoaded) return;
  window.themeDescClampLoaded = true;

  var BUFFER = 40; /* never clamp away just a line or two */

  function maxHeightFor(clamp) {
    var v = parseFloat(getComputedStyle(clamp).getPropertyValue('--desc-clamp-max-height'));
    return isNaN(v) ? 230 : v;
  }

  /* If the surrounding collapsible tab is mid-animation it has a fixed
     inline height - retarget it so our height change is not clipped.
     (Symmetry's DetailsDisclosure clears the inline height on transitionend,
     so an open tab is height:auto and needs nothing.) */
  function refreshPanelHeight(clamp) {
    var panel = clamp.closest('.disclosure__panel');
    if (panel && panel.style.height) {
      panel.style.height = panel.scrollHeight + 'px';
    }
  }

  function setLabel(btn, expanded) {
    btn.textContent = expanded
      ? btn.getAttribute('data-label-less') || 'Read less'
      : btn.getAttribute('data-label-more') || 'Read more';
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function toggle(clamp, btn) {
    var expanded = clamp.classList.toggle('is-expanded');
    setLabel(btn, expanded);
    refreshPanelHeight(clamp);

    if (!expanded) {
      /* Collapsing: if the top of the description is above the viewport
         (or under the sticky header), bring it back into view. */
      var top = clamp.getBoundingClientRect().top;
      var header = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height')
      ) || 0;
      if (top < header) {
        window.scrollBy(0, top - header - 16);
      }
    }
  }

  /* The description tab is always open: "Read more" does the expanding,
     so the heading's +/- is redundant (hidden in the CSS).
     Symmetry's DetailsDisclosure binds its own click handler on the
     summary and closes the panel programmatically, so preventDefault on
     the summary is not enough - the click has to be stopped in the
     capture phase, before that handler ever runs. */
  function makeStatic(details) {
    if (details.hasAttribute('data-desc-static-bound')) return;
    details.setAttribute('data-desc-static-bound', 'true');
    details.classList.add('desc-static');

    details.addEventListener(
      'click',
      function (evt) {
        var summary = evt.target && evt.target.closest ? evt.target.closest('summary') : null;
        if (summary && summary.parentElement === details) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
        }
      },
      true
    );
  }

  /* Never leave the description collapsed (e.g. a click that landed
     before this script ran, or a mid-animation state). */
  function forceOpen(details) {
    if (details.open && !details.classList.contains('is-closing')) return;
    details.classList.remove('is-closing');
    details.open = true;
    var panel = details.querySelector('.disclosure__panel');
    if (panel) panel.removeAttribute('style');
  }

  function assess(clamp) {
    var inner = clamp.querySelector('.desc-clamp__inner');
    var btn = clamp.querySelector('.desc-clamp__toggle');
    if (!inner || !btn) return;

    var details = clamp.closest('details');

    if (!clamp.hasAttribute('data-desc-clamp-bound')) {
      clamp.setAttribute('data-desc-clamp-bound', 'true');
      btn.addEventListener('click', function () {
        toggle(clamp, btn);
      });
      if (details) {
        details.addEventListener('toggle', function () {
          assess(clamp);
        });
        makeStatic(details);
      }
    }

    if (details) forceOpen(details);

    /* Hidden (quickbuy-hidden...): cannot measure - leave as-is. */
    if (!inner.scrollHeight) return;

    var overflows = inner.scrollHeight > maxHeightFor(clamp) + BUFFER;

    if (!overflows) {
      clamp.classList.remove('desc-clamp--active', 'is-expanded');
      setLabel(btn, false);
      return;
    }

    /* Overflows. Keep the user's choice if they already expanded. */
    if (clamp.classList.contains('is-expanded')) return;

    if (!clamp.classList.contains('desc-clamp--active')) {
      clamp.classList.add('desc-clamp--active');
      setLabel(btn, false);
      refreshPanelHeight(clamp);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var clamps = scope.querySelectorAll('[data-desc-clamp]');
    for (var i = 0; i < clamps.length; i++) assess(clamps[i]);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAll();
    }, 150);
  });

  /* Re-measure once images inside the description have loaded. */
  window.addEventListener('load', function () {
    initAll();
  });

  /* Theme editor: sections are re-rendered on the fly. */
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
